import { render, staticRenderFns } from "./NumberDoubleField.vue?vue&type=template&id=122ad96c"
import script from "./NumberDoubleField.vue?vue&type=script&lang=js"
export * from "./NumberDoubleField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports